import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import SmartImage from "../components/SmartImage";
import Lightbox from "../components/Lightbox";
import Breadcrumbs from "../components/Breadcrumbs";
import { EmptyState, SkeletonGrid } from "../components/States";

export default function Builds() {
  const [builds, setBuilds] = useState(null);
  const [lb, setLb] = useState(null);

  useEffect(() => {
    api
      .get("/builds")
      .then((r) => setBuilds(r.data.builds || []))
      .catch(() => setBuilds([]));
  }, []);

  return (
    <div data-testid="builds-page">
      <section className="border-b" style={{ borderColor: "rgba(255,255,255,0.08)", background: "var(--nq-ink)" }}>
        <div className="container-nq py-10">
          <Breadcrumbs items={[{ slug: "our-builds", label: "Our builds" }]} />
          <p className="eyebrow mt-4">Gallery</p>
          <h1 className="mt-2 text-3xl font-bold md:text-5xl">Our Builds</h1>
          <p className="mt-3 max-w-2xl text-sm text-[color:var(--nq-stone)] md:text-base">
            A look at the rigs, trucks and touring setups that have come through the NQ Springs
            workshop.
          </p>
        </div>
      </section>

      <div className="container-nq section-nq">
        {!builds ? (
          <SkeletonGrid count={9} />
        ) : builds.length === 0 ? (
          <EmptyState title="No builds yet" message="Check back soon." />
        ) : (
          <>
            <p className="mb-6 text-xs text-[color:var(--nq-stone)]">{builds.length} photos</p>
            <div className="grid grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-4" data-testid="gallery-grid">
              {builds.map((b, i) => (
                <button
                  key={b.id}
                  type="button"
                  onClick={() => setLb(i)}
                  className="card-nq cursor-zoom-in"
                  data-testid="gallery-item"
                >
                  <SmartImage src={b.image} alt={b.title} ratio="aspect-square" fit="cover" />
                  {b.vehicle && (
                    <p className="truncate px-3 py-2 text-left text-xs text-[color:var(--nq-stone)]">{b.vehicle}</p>
                  )}
                </button>
              ))}
            </div>
          </>
        )}

        <div className="mt-12 text-center">
          <p className="text-sm text-[color:var(--nq-stone)]">Want your rig built like this?</p>
          <Link to="/enquire" className="btn-gold mt-3" data-testid="builds-enquire-cta">
            Talk to us about your build
          </Link>
        </div>
      </div>

      <Lightbox
        images={(builds || []).map((b) => b.image)}
        index={lb}
        onClose={() => setLb(null)}
        onIndex={setLb}
      />
    </div>
  );
}
